module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//28.jpg?2fbd69d3d1711120cf28ac271b31c068";